const SET_QUOTE = 'mrDistribution/SET_QUOTE';
const CLEAN_QUOTE = 'mrDistribution/CLEAN_QUOTE';

const SET_QUOTE_ERROR = 'mrDistribution/SET_QUOTE_ERROR';
const CLEAN_QUOTE_ERROR = 'mrDistribution/CLEAN_QUOTE_ERROR';

export default {
  SET_QUOTE,
  CLEAN_QUOTE,

  SET_QUOTE_ERROR,
  CLEAN_QUOTE_ERROR,
};
